<div class="modal-header">
    <h5 class="modal-title">{{ 'formMainSettings.title' | t }}</h5>
</div>
@if (sd) {
    <mat-dialog-content class="overflow-dialog">
        <mat-tab-group animationDuration="0ms">
            <mat-tab [label]="'formMainSettings.generalTab' | t" data-uiid="forms-main-settings-general-tab">
                <div class="container-fluid">
                    <div class="form-group">
                        <label for="form-title">{{ 'formMainSettings.titleLabel' | t }}</label>
                        <cerrix-textfield
                            dataUiid="forms-main-settings-title-input"
                            cssClass="form-control"
                            id="form-title"
                            [(ngModel)]="form.Title"
                            placeholder="{{ 'formMainSettings.titlePlaceholder' | t }}"
                        ></cerrix-textfield>
                    </div>
                    <div class="form-group">
                        <label for="form-description">{{ 'formMainSettings.descriptionLabel' | t }}</label>
                        <cerrix-textarea
                            dataUiid="forms-main-settings-description-input"
                            cssClass="form-control"
                            id="form-description"
                            aria-describedby="emailHelp"
                            [(ngModel)]="form.Description"
                            placeholder="{{ 'formMainSettings.descriptionPlaceholder' | t }}"
                        ></cerrix-textarea>
                    </div>
                    <div class="form-group">
                        <label for="form-groups">{{ 'formMainSettings.categoryLabel' | t }}</label>
                        <ng-select
                            data-uiid="forms-main-settings-category-select"
                            [(ngModel)]="form.Category"
                            id="form-groups"
                            [items]="sd.categories"
                            bindValue="ID"
                            bindLabel="Name"
                            [closeOnSelect]="true"
                            [multiple]="false"
                        >
                        </ng-select>
                        @if (!sd.categories || sd.categories.length === 0) {
                            <div
                                class="alert alert-danger small-alert system-required"
                                role="alert"
                            >
                                {{ 'formMainSettings.noCategoriesFound' | t }}
                            </div>
                        }
                    </div>
                    <div class="row">
                        <div class="form-group col-md-6">
                            <label for="form-startdate">{{ 'formMainSettings.startDateLabel' | t }}</label>
                            <date-input
                                data-uiid="forms-main-settings-startdate-input"
                                [(value)]="form.StartDate"
                            ></date-input>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="form-enddate">{{ 'formMainSettings.endDateLabel' | t }}</label>
                            <date-input
                                data-uiid="forms-main-settings-enddate-input"
                                [(value)]="form.EndDate"
                            ></date-input>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab [label]="'formMainSettings.assignedUsersTab' | t" data-uiid="forms-main-settings-assigned-users-tab">
                <div class="container-fluid">
                    <div class="form-group">
                        <label for="form-groups">{{ 'formMainSettings.responsiblesLabel' | t }}</label>
                        <ng-select
                            data-uiid="forms-main-settings-responsibles-select"
                            [(ngModel)]="form.Responsibles"
                            id="form-groups"
                            [items]="sd.responsibles"
                            bindValue="ID"
                            bindLabel="Name"
                            [closeOnSelect]="false"
                            [multiple]="true"
                        >
                        </ng-select>
                    </div>
                    <div class="form-group">
                        <label for="form-groups">{{ 'formMainSettings.designersLabel' | t }}</label>
                        <ng-select
                            data-uiid="forms-main-settings-designers-select"
                            [(ngModel)]="form.Designers"
                            id="form-groups"
                            [items]="sd.designers"
                            bindValue="ID"
                            bindLabel="Name"
                            [closeOnSelect]="false"
                            [multiple]="true"
                        >
                        </ng-select>
                    </div>
                    <hr />
                    <div class="form-group">
                        <label for="form-groups">{{ 'formMainSettings.entryGroupsLabel' | t }}</label>
                        @if (form.Workflow) {
                            <input
                                type="text"
                                class="form-control"
                                value="{{ 'formMainSettings.workflowGroupsInfo' | t }}"
                                disabled
                                inputTooltip
                            />
                        } @else {
                            <ng-select
                                data-uiid="forms-main-settings-entrygroups-select"
                                [(ngModel)]="form.Groups"
                                id="form-groups"
                                [items]="sd.entryGroups"
                                bindValue="ID"
                                bindLabel="Name"
                                [closeOnSelect]="false"
                                [multiple]="true"
                            >
                            </ng-select>
                        }
                    </div>
                    <div class="form-group">
                        <label for="form-groups">{{ 'formMainSettings.dataOwnerGroupsLabel' | t }}</label>
                        <ng-select
                            data-uiid="forms-main-settings-data-owners-select"
                            [(ngModel)]="form.DataOwners"
                            id="form-groups"
                            [items]="sd.dataOwnerGroups"
                            bindValue="ID"
                            bindLabel="Name"
                            [closeOnSelect]="false"
                            [multiple]="true"
                        >
                        </ng-select>
                        <small class="text-muted">{{ 'formMainSettings.dataOwnerGroupsInfo' | t }}</small>
                    </div>
                </div>
            </mat-tab>
            <mat-tab [label]="'formMainSettings.designTab' | t" data-uiid="forms-main-settings-design-tab">
                <div class="container-fluid">
                    <label for="form-image">{{ 'formMainSettings.formImageLabel' | t }}</label>
                    <cerrix-image-picker
                        data-uiid="forms-main-settings-image-picker"
                        maxHeight="500px"
                        [(image)]="form.ImageGuid"
                        [fallbackImageUrl]="'/static/images/form_logo_fallback.jpg'"
                    >
                    </cerrix-image-picker>
                </div>
            </mat-tab>
            <mat-tab [label]="'formMainSettings.advancedTab' | t" data-uiid="forms-main-settings-advanced-tab">
                <div class="container-fluid">
                    <div class="form-group">
                        <cerrix-checkbox
                            data-uiid="forms-main-settings-enable-summary-checkbox"
                            [label]="'formMainSettings.enableSummary' | t"
                            [(value)]="form.ShowSummary"
                        ></cerrix-checkbox>
                        <cerrix-checkbox
                            data-uiid="forms-main-settings-limit-entry-checkbox"
                            [label]="'formMainSettings.limitSingleEntry' | t"
                            [(value)]="form.IsSingleEntry"
                        >
                        </cerrix-checkbox>
                        <small class="form-text text-muted mt-0">{{ 'formMainSettings.limitSingleEntryInfo' | t }}</small>
                    </div>
                    <hr />
                    <cerrix-checkbox
                        data-uiid="forms-main-settings-enable-workflow-checkbox"
                        [label]="'formMainSettings.enableWorkflow' | t"
                        [(value)]="form.Workflow"
                        [disabled]="form.ID > 0"
                    >
                    </cerrix-checkbox>
                    <div class="form-group" [hidden]="!form.Workflow">
                        <label for="form-title">{{ 'formMainSettings.stallingDaysLabel' | t }}</label>
                        <input
                            data-uiid="forms-main-settings-reviewer-stallingdays-input"
                            type="number"
                            class="form-control"
                            id="form-MaxStallingDays"
                            [(ngModel)]="form.MaxStallingDays"
                            min="0"
                            max="1000"
                        />
                        <small class="form-text text-muted mt-0">{{ 'formMainSettings.stallingDaysInfo' | t }}</small>
                        @if (form.MaxStallingDays > 0) {
                            <small class="form-text text-muted mt-0">{{
                                'formMainSettings.stallingDaysCheckInfo' | t: { hours: form.MaxStallingDays * 24 }
                            }}</small>
                        }
                    </div>
                    <hr />
                    @if (!form.MapBack || form.MapBack === 0) {
                        <div class="form-group">
                            <small class="form-text text-muted mt-0">{{ 'formMainSettings.reopenInfo' | t }}</small>
                            <cerrix-checkbox
                                [label]="'formMainSettings.reopenEntryStarter' | t"
                                data-uiid="forms-main-settings-entry-starter-checkbox"
                                [(value)]="form.AllowReopenEntryStarter"
                            >
                            </cerrix-checkbox>
                            <cerrix-checkbox
                                data-uiid="forms-main-settings-last-reviewer-checkbox"
                                [label]="'formMainSettings.reopenLastReviewer' | t"
                                [disabled]="!form.Workflow"
                                [(value)]="form.AllowReopenLastReviewer"
                            >
                            </cerrix-checkbox>
                            <cerrix-checkbox
                                [label]="'formMainSettings.reopenFormsDataOwners' | t"
                                data-uiid="forms-main-settings-data-owners-checkbox"
                                [disabled]="!form.DataOwners || form.DataOwners.length === 0"
                                [(value)]="form.AllowReopenFormsDataOwners"
                            >
                            </cerrix-checkbox>
                            <hr />
                        </div>
                    }
                    @if (sd.mapbackClasses && sd.mapbackClasses.length > 0) {
                        <div class="form-group">
                            <label for="form-mapback">{{ 'formMainSettings.mapbackLabel' | t }}</label>
                            <ng-select
                                data-uiid="forms-main-settings-mapback-select"
                                [(ngModel)]="form.MapBack"
                                id="form-groups"
                                [items]="sd.mapbackClasses"
                                [multiple]="false"
                                bindValue="ID"
                                bindLabel="Name"
                                [disabled]="form.ID > 0"
                                [dropdownPosition]="'top'"
                            >
                            </ng-select>
                        </div>
                    }
                </div>
            </mat-tab>
            <mat-tab [label]="'formMainSettings.linksTab' | t" data-uiid="forms-main-settings-links-tab">
                <div class="container-fluid">
                    <label for="form-links">{{ 'formMainSettings.moduleLabel' | t }}</label>
                    @if (linkableModules) {
                        <ng-select
                            data-uiid="forms-main-settings-module-select"
                            (change)="moduleChanged($event)"
                            [(ngModel)]="form.LinkedModule"
                            id="form-linkedmodule"
                            [multiple]="false"
                            [items]="linkableModules"
                            bindValue="ID"
                            bindLabel="Name"
                            [disabled]="moduleDisabled"
                        >
                        </ng-select>
                    }
                    @if (moduleDisabled) {
                        <small class="text-muted">{{ 'formMainSettings.moduleDisabledInfo' | t }}</small>
                    }

                    <div class="form-group"></div>
                    @if (selectedLinkedModule) {
                        <app-linkable
                            [typename]="typename"
                            [disabled]="true"
                            [displayValueProp]="displayValueProp"
                            [linked]="linked"
                            [unlinked]="unlinked"
                        ></app-linkable>
                    }
                </div>
            </mat-tab>
        </mat-tab-group>
    </mat-dialog-content>
} @else {
    <div class="fancy-loader submodule"></div>
}

<div class="modal-footer">
    <button
        type="button"
        data-uiid="forms-main-settings-save-button"
        class="btn btn-primary"
        (click)="onSaveChanges()"
    >
        {{ 'formMainSettings.applyChangesBtn' | t }}
    </button>
    <button
        type="button"
        data-uiid="forms-main-settings-cancel-button"
        class="btn btn-secondary"
        data-bs-dismiss="modal"
    >
        {{ 'formMainSettings.cancelBtn' | t }}
    </button>
</div>
